// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/instrument-groups-scan.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/instrument-groups-scan/instrument-groups-scan.js';

mount([g0]);
